import React, { useState, useRef, useMemo, useEffect } from 'react';
import '../../CSS/Additionalbill.css';
import api from '../../api.js';
import { useRights } from "../../Components/RightsContext.jsx";

/* ════════════════════════ STATIC DATA ════════════════════════ */
const Additionalbill_PATH = "/Transaction/Additionalbill";
const COMPANY = {
  name: 'SAAMI TRADESTAR LOGISTICS PVT LTD',
  gstin: '27AABCS1234A1ZP',
  state: '27',
  stateName: 'Maharashtra',
  addr: 'Plot 14, Transport Nagar, Bhiwandi, Maharashtra 421302',
};

// We will fetch these from API now
// const INITIAL_BILLS = [
//   TML: [{ code: 'JOB-TML-01', name: 'Spare Parts Distribution' }, { code: 'JOB-TML-02', name: 'Inbound Line Feed' }],
//   MAH: [{ code: 'JOB-MAH-01', name: 'Aftermarket Parts' }, { code: 'JOB-MAH-02', name: 'Plant Logistics' }],
//   BAL: [{ code: 'JOB-BAL-01', name: '2W Spares Movement' }, { code: 'JOB-BAL-02', name: 'Export Packing' }],
//   FRC: [{ code: 'JOB-FRC-01', name: 'CV Parts Supply' }, { code: 'JOB-FRC-02', name: 'Service Support' }],
//   MSI: [{ code: 'JOB-MSI-01', name: 'Genuine Parts Dispatch' }, { code: 'JOB-MSI-02', name: 'Dealer Distribution' }],
//   MNL: [{ code: 'JOB-MNL-01', name: 'Wiring Harness Supply' }, { code: 'JOB-MNL-02', name: 'Module Line Feed' }],
//   BSH: [{ code: 'JOB-BSH-01', name: 'Auto Components' }, { code: 'JOB-BSH-02', name: 'Service Exchange' }],
//   SVP: [{ code: 'JOB-SVP-01', name: 'Cooling Systems OEM' }, { code: 'JOB-SVP-02', name: 'Aftermarket Supply' }],
//   ASH: [{ code: 'JOB-ASH-01', name: 'CV Spares Movement' }, { code: 'JOB-ASH-02', name: 'Fleet Support' }],
// };

const UOMS = ['Days', 'Hour', 'Nos', 'Trip', 'Visit', 'Kg', 'MT', 'Pkg', 'Pallet', 'Box', 'KM', 'Lump Sum'];

const HEADS = [
  { code: 'DETENTION', name: 'Detention Charges', sac: '996791', gst: 18, uom: 'Days' },
  { code: 'DEMURRAGE', name: 'Demurrage', sac: '996791', gst: 18, uom: 'Days' },
  { code: 'HAMALI', name: 'Loading / Unloading (Hamali)', sac: '996799', gst: 18, uom: 'Nos' },
  { code: 'DOORDEL', name: 'Door Delivery', sac: '996511', gst: 18, uom: 'Trip' },
  { code: 'REDEL', name: 'Re-delivery / Re-attempt', sac: '996511', gst: 18, uom: 'Trip' },
  { code: 'STORAGE', name: 'Storage / Warehousing', sac: '996729', gst: 18, uom: 'Days' },
  { code: 'HANDLING', name: 'Handling Charges', sac: '996799', gst: 18, uom: 'Nos' },
  { code: 'PACKING', name: 'Packing / Repacking', sac: '998540', gst: 18, uom: 'Pkg' },
  { code: 'ODC', name: 'ODC / Over-dimensional', sac: '996511', gst: 18, uom: 'Trip' },
  { code: 'WAITING', name: 'Waiting / Halt Charges', sac: '996791', gst: 18, uom: 'Hour' },
  { code: 'TOLL', name: 'Toll / Octroi Reimbursement', sac: '996791', gst: 18, uom: 'Trip' },
  { code: 'INSURANCE', name: 'Insurance / Risk', sac: '997135', gst: 18, uom: 'Lump Sum' },
  { code: 'COLDCHAIN', name: 'Cold Chain Surcharge', sac: '996799', gst: 18, uom: 'Trip' },
  { code: 'MISC', name: 'Miscellaneous Charges', sac: '996799', gst: 18, uom: 'Nos' },
];

const INITIAL_BILLS = [
  {
    no: 'STL-ADB-2606-0018', date: '2026-06-18', branch: 'Mumbai', party: 'Tata Motors Ltd', partyCode: 'TML', jobCode: 'JOB-TML-01', jobName: 'Spare Parts Distribution', refType: 'Consignment', refNo: 'STL-2604-00821',
    lines: [
      { head: 'DETENTION', desc: '2 days detention', cnr: 'STL-2604-00821', sac: '996791', qty: 2, uom: 'Days', rate: 600, gst: 18 },
      { head: 'HAMALI', desc: 'Manual unloading', cnr: 'STL-2604-00821', sac: '996799', qty: 1, uom: 'Nos', rate: 350, gst: 18 },
    ], status: 'generated', remark: ''
  },
  {
    no: 'STL-ADB-2606-0017', date: '2026-06-16', branch: 'Bengaluru', party: 'Bosch Ltd', partyCode: 'BSH', jobCode: 'JOB-BSH-01', jobName: 'Auto Components', refType: 'Invoice', refNo: 'STL-INV-2606-0102',
    lines: [{ head: 'STORAGE', desc: '5 days storage', cnr: '', sac: '996729', qty: 5, uom: 'Days', rate: 200, gst: 18 }], status: 'paid', remark: ''
  },
  {
    no: 'STL-ADB-2606-0015', date: '2026-06-14', branch: 'Delhi', party: 'Maruti Suzuki India Ltd', partyCode: 'MSI', jobCode: 'JOB-MSI-01', jobName: 'Genuine Parts Dispatch', refType: 'Consignment', refNo: 'STL-2604-00790',
    lines: [{ head: 'DOORDEL', desc: 'Door delivery beyond ODA', cnr: 'STL-2604-00790', sac: '996511', qty: 1, uom: 'Trip', rate: 1200, gst: 18 }], status: 'generated', remark: ''
  },
];

/* ════════════════════════ UTILITIES ════════════════════════ */
// Case-insensitive key lookup — mirrors RateDefinition.jsx's ComboBox
// normalization, so mismatched API casing (BranchId vs Branch_Id vs
// branch_id) no longer silently produces an empty value.
function findKeyCI(obj, candidates) {
  if (!obj) return undefined;
  const keys = Object.keys(obj);
  for (const cand of candidates) {
    const k = keys.find(kk => kk.toLowerCase() === cand.toLowerCase());
    if (k !== undefined && obj[k] !== null && obj[k] !== undefined) return obj[k];
  }
  return undefined;
}
function extractValueLabel(obj, type) {
  if (!obj) return { value: '', label: '' };
  if (type === 'branch') {
    return {
      value: String(findKeyCI(obj, ['branch_id', 'branchid', 'id', 'value']) ?? ''),
      label: String(findKeyCI(obj, ['branch_name', 'branchname', 'name', 'label']) ?? ''),
    };
  }
  if (type === 'party') {
    return {
      value: String(findKeyCI(obj, ['party_id', 'partyid', 'id', 'value']) ?? ''),
      label: String(findKeyCI(obj, ['party_name', 'partyname', 'name', 'label']) ?? ''),
    };
  }
  if (type === 'job') {
    return {
      value: String(findKeyCI(obj, ['job_id', 'jobid', 'id', 'value']) ?? ''),
      label: String(findKeyCI(obj, ['job_name', 'jobname', 'name', 'label']) ?? ''),
    };
  }
  return {
    value: String(findKeyCI(obj, ['id', 'value']) ?? ''),
    label: String(findKeyCI(obj, ['name', 'label']) ?? ''),
  };
}
function fmt(n) {
  return (Math.round((n || 0) * 100) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
function fmtK(n) {
  n = Math.round((n || 0) * 100) / 100;
  return n >= 100000 ? (n / 100000).toFixed(1) + 'L' : n >= 1000 ? (n / 1000).toFixed(n >= 10000 ? 0 : 1) + 'K' : (Number.isInteger(n) ? n : n.toFixed(2));
}
function fmtDate(d) {
  return new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
}
function numWords(n) {
  if (!n) return '—';
  const o = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
  const t = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  function w(n) {
    if (n === 0) return '';
    if (n < 20) return o[n] + ' ';
    if (n < 100) return t[Math.floor(n / 10)] + ' ' + (n % 10 ? o[n % 10] + ' ' : '');
    if (n < 1000) return o[Math.floor(n / 100)] + ' Hundred ' + (n % 100 ? w(n % 100) : '');
    if (n < 100000) return w(Math.floor(n / 1000)) + 'Thousand ' + (n % 1000 ? w(n % 1000) : '');
    if (n < 10000000) return w(Math.floor(n / 100000)) + 'Lakh ' + (n % 100000 ? w(n % 100000) : '');
    return w(Math.floor(n / 10000000)) + 'Crore ' + (n % 10000000 ? w(n % 10000000) : '');
  }
  return 'Rupees ' + w(n).trim() + ' Only';
}
function billTotals(b) {
  let tax = 0, gst = 0;
  b.lines.forEach(l => { const t = l.qty * l.rate; tax += t; gst += t * l.gst / 100; });
  return { tax, gst, total: Math.round(tax + gst) };
}

/* ════════════════════════ ICONS ════════════════════════ */
const IcPlus = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M12 5v14M5 12h14" /></svg>;
const IcBack = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>;
const IcDoc = () => <svg viewBox="0 0 24 24" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>;
const IcMoney = () => <svg viewBox="0 0 24 24" strokeWidth="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /></svg>;
const IcGrid = () => <svg viewBox="0 0 24 24" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /></svg>;
const IcTax = () => <svg viewBox="0 0 24 24" strokeWidth="2"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /></svg>;
const IcNote = () => <svg viewBox="0 0 24 24" strokeWidth="2"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" /></svg>;
const IcFilter = () => <svg viewBox="0 0 24 24" strokeWidth="2"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>;
const IcEdit = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" /><path d="M18.5 2.5a2.12 2.12 0 013 3L12 15l-4 1 1-4 9.5-9.5z" /></svg>;
const IcTrash = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6" /><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" /></svg>;
const IcSave = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v14a2 2 0 01-2 2z" /><polyline points="17 21 17 13 7 13 7 21" /><polyline points="7 3 7 8 15 8" /></svg>;
const IcPrint = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 6 2 18 2 18 9" /><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" /><rect x="6" y="14" width="12" height="8" /></svg>;
const IcLogo = () => <svg viewBox="0 0 24 24"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm13.5 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" /></svg>;

/* ════════════════════════ COMBO BOX ════════════════════════ */
function AblCombo({ options, value, onChange, placeholder, disabled }) {
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [hl, setHl] = useState(-1);
  const [cursorMoved, setCursorMoved] = useState(false);
  const wrapRef = useRef(null);
  const inputRef = useRef(null);
  const optionRefs = useRef([]);

  const selected = options.find(o => String(o.value) === String(value));

  // Keep displayed text in sync with the selected value — matters when
  // `value` changes programmatically (e.g. parent resets the field), not
  // just when the user picks from the list.
  useEffect(() => {
    if (selected) setQuery(selected.label);
    else setQuery('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, selected]);

  const filtered = options.filter(
    o => o.value !== undefined && o.label != null && o.label.toLowerCase().includes((query || '').toLowerCase())
  );

  // Auto-scroll the keyboard-highlighted option into view — without this,
  // ArrowDown/ArrowUp can move the highlight past the dropdown's visible
  // area (max-height) with no visual feedback that navigation is happening.
  useEffect(() => {
    if (hl >= 0 && optionRefs.current[hl]) {
      try {
        optionRefs.current[hl].scrollIntoView({ block: 'nearest' });
      } catch (err) {
        // scrolling is a nice-to-have — never let it block keyboard nav
      }
    }
  }, [hl]);

  useEffect(() => {
    function handle(e) {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, []);

  function pick(o) {
    if (!o) return;
    onChange(o.value);
    setQuery(o.label);
    setOpen(false);
    setHl(-1);
    setCursorMoved(false);
  }

  function clear() {
    onChange('');
    setQuery('');
    setOpen(true);
    setHl(-1);
  }

  // Advance focus to the next focusable field on the page — mirrors the
  // Booking Place field's behavior so Enter/Tab moves you straight along
  // the form instead of requiring a mouse click into the next field.
  function focusNext() {
    const focusable = Array.from(
      document.querySelectorAll(
        'input:not([disabled]):not([readonly]):not([type="hidden"]):not([type="checkbox"]), select:not([disabled]), textarea:not([disabled]):not([readonly]), button:not([disabled])'
      )
    ).filter(el => el.offsetParent !== null);
    const idx = focusable.indexOf(inputRef.current);
    if (idx !== -1 && idx < focusable.length - 1) focusable[idx + 1].focus();
  }

  function handleKeyDown(e) {
    if (disabled) return;

    if (!open) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        setOpen(true);
        setCursorMoved(true);
      } else if (e.key === 'Enter') {
        focusNext();
      }
      return;
    }

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      setCursorMoved(true);
      setHl(h => Math.min(h + 1, filtered.length - 1));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      setCursorMoved(true);
      setHl(h => Math.max(h - 1, 0));
    } else if (e.key === 'Escape') {
      setOpen(false);
    } else if (e.key === 'Enter') {
      e.preventDefault();
      if (cursorMoved && filtered.length > 0) {
        const target = filtered[hl] || filtered[0];
        if (target) pick(target);
      } else if (filtered.length === 1) {
        pick(filtered[0]);
      } else {
        setOpen(false);
      }
      setTimeout(focusNext, 20);
    }
  }

  function highlightMatch(lbl) {
    const q = (query || '').toLowerCase();
    if (!q) return lbl;
    const idx = lbl.toLowerCase().indexOf(q);
    if (idx < 0) return lbl;
    return <>{lbl.slice(0, idx)}<mark>{lbl.slice(idx, idx + q.length)}</mark>{lbl.slice(idx + q.length)}</>;
  }

  return (
    <div className={'abl-combo' + (disabled ? ' abl-disabled' : '')} ref={wrapRef}>
      <input
        ref={inputRef}
        className="abl-combo-input"
        type="text"
        autoComplete="off"
        spellCheck="false"
        placeholder={placeholder}
        disabled={disabled}
        value={query}
        onFocus={() => { if (disabled) return; setOpen(true); setCursorMoved(false); }}
        onClick={() => { if (!open) setOpen(true); }}
        onChange={e => { setQuery(e.target.value); setOpen(true); setHl(-1); }}
        onKeyDown={handleKeyDown}
      />
      {value && !disabled && (
        <button
          type="button"
          className="abl-combo-x on"
          onMouseDown={e => { e.preventDefault(); clear(); }}
          tabIndex={-1}
        >×</button>
      )}
      <svg className="abl-combo-caret" viewBox="0 0 11 7"><path d="M1 1l4.5 4.5L10 1" stroke="#94a3b8" strokeWidth="1.6" fill="none" strokeLinecap="round" /></svg>
      {open && (
        <div className="abl-combo-panel abl-open">
          {filtered.length === 0 ? (
            <div className="abl-combo-empty">No matches</div>
          ) : filtered.map((o, i) => (
            <div
              key={String(o.value) + '_' + i}
              ref={el => { optionRefs.current[i] = el; }}
              className={'abl-combo-opt' + (i === hl ? ' abl-hl' : '') + (String(o.value) === String(value) ? ' abl-sel' : '')}
              onMouseDown={e => { e.preventDefault(); pick(o); }}
              onMouseEnter={() => setHl(i)}
            >
              {highlightMatch(o.label)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

/* ════════════════════════ MAIN COMPONENT ════════════════════════ */
export default function AdditionalBill() {
  const rights = useRights(Additionalbill_PATH);
  const [view, setView] = useState('list'); // 'list' | 'builder'
  const [bills, setBills] = useState([]);
  const [billsLoading, setBillsLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  // Api Dropdown Data
  const [branches, setBranches] = useState([]);
  const [parties, setParties] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [allParties, setAllParties] = useState([]);
  const [refTypes, setRefTypes] = useState([]);
  const [chargeHeads, setChargeHeads] = useState([]);

  useEffect(() => {
    api.get('/dropdown?mode=BLB')
      .then(r => setBranches(Array.isArray(r.data) ? r.data : []))
      .catch(e => console.error('Error fetching branches:', e));

    api.get('/dropdown?mode=bPRT')
      .then(r => setAllParties(Array.isArray(r.data) ? r.data : []))
      .catch(e => console.error('Error fetching all parties:', e));

    api.get('/dropdown?mode=REF')
      .then(r => setRefTypes(Array.isArray(r.data) ? r.data : []))
      .catch(e => console.error('Error fetching reference types:', e));

    api.get('/dropdown?mode=CHD')
      .then(r => setChargeHeads(Array.isArray(r.data) ? r.data : []))
      .catch(e => console.error('Error fetching charge heads:', e));
  }, []);

  // builder header fields
  const [curBillNo, setCurBillNo] = useState(null);
  const [builderTitle, setBuilderTitle] = useState('Generate Additional Bill');
  const [billDate, setBillDate] = useState('');
  const [refType, setRefType] = useState('');
  const [refNo, setRefNo] = useState('');
  const [branch, setBranch] = useState('');
  const [partyCode, setPartyCode] = useState('');
  const [jobCode, setJobCode] = useState('');
  const [remark, setRemark] = useState('');

  // charge lines
  const [lines, setLines] = useState([]);
  const [editIndex, setEditIndex] = useState(-1);

  // charge entry fields
  const [cHead, setCHead] = useState('');
  const [cDesc, setCDesc] = useState('');
  const [cCnr, setCCnr] = useState('');
  const [cQty, setCQty] = useState('1');
  const [cUom, setCUom] = useState('Nos');
  const [cRate, setCRate] = useState('');
  const [cGst, setCGst] = useState('18');

  // filters
  const [fBranch, setFBranch] = useState('');
  const [fParty, setFParty] = useState('');
  const [fParties, setFParties] = useState([]);
  const todayStr = new Date().toISOString().slice(0, 10);
  const [fFrom, setFFrom] = useState(todayStr);
  const [fTo, setFTo] = useState(todayStr);

  // toasts
  const [toasts, setToasts] = useState([]);
  const toastId = useRef(0);

  // print
  const [printRec, setPrintRec] = useState(null);

  const curParty = parties.find(p => extractValueLabel(p, 'party').value === partyCode) || null;
  const [partyDetails, setPartyDetails] = useState(null);
  const curJob = jobs.find(j => extractValueLabel(j, 'job').value === jobCode) || null;

  function toast(msg, type) {
    const id = ++toastId.current;
    setToasts(t => [...t, { id, msg, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 2800);
  }

  /* ── OPTIONS ── */
  // Reference_Type shows as the dropdown option label; Reference_Name_Display
  // is reused as the NEXT field's label (e.g. "Consignment No.", "Freight
  // Invoice No.") once a reference type is picked.
  const refTypeRows = refTypes.map(r => ({
    id: String(findKeyCI(r, ['reference_type_id', 'referencetypeid', 'id', 'value']) ?? ''),
    type: String(findKeyCI(r, ['reference_type', 'referencetype', 'name', 'label']) ?? ''),
    display: String(findKeyCI(r, ['reference_name_display', 'referencenamedisplay']) ?? ''),
  }));
  const refTypeOptions = [
    { value: '', label: '' },
    ...refTypeRows.map(r => ({ value: r.id, label: r.type })),
  ];
  const selectedRefType = refTypeRows.find(r => String(r.id) === String(refType));
  const branchOptions = [{ value: '', label: '' }, ...branches.map(b => extractValueLabel(b, 'branch'))];
  const partyOptions = branch
    ? [{ value: '', label: '' }, ...parties.map(p => extractValueLabel(p, 'party'))]
    : [{ value: '', label: '' }];
  const jobOptions = partyCode
    ? [{ value: '', label: '' }, ...jobs.map(j => {
      const jl = extractValueLabel(j, 'job');
      return { value: jl.value, label: jl.label };
    })]
    : [{ value: '', label: '' }];
  // Charge_Head table only gives us Charge_HeadId/Charge_Head — no SAC/GST/UOM.
  // Those still live in the local HEADS metadata table, so we bridge the two
  // by matching on name (case-insensitive), falling back to sane defaults
  // (never crashing) when a real head has no matching local metadata row.
  const chargeHeadRows = chargeHeads.map(c => ({
    id: String(findKeyCI(c, ['charge_headid', 'chargeheadid', 'id', 'value']) ?? ''),
    name: String(findKeyCI(c, ['charge_head', 'chargehead', 'name', 'label']) ?? ''),
  }));
  const headOptions = [
    { value: '', label: '' },
    ...chargeHeadRows.map(c => ({ value: c.id, label: c.name })),
  ];
  function getHeadMeta(headId) {
    const row = chargeHeadRows.find(c => String(c.id) === String(headId));
    if (!row) return { name: '', sac: '—', gst: 18, uom: 'Nos' };
    const meta = HEADS.find(h => h.name.toLowerCase() === row.name.toLowerCase());
    return { name: row.name, sac: meta?.sac || '—', gst: meta?.gst ?? 18, uom: meta?.uom || 'Nos' };
  }
  const uomOptions = UOMS.map(u => ({ value: u, label: u }));
  const gstOptions = [18, 12, 5, 28, 0].map(g => ({ value: String(g), label: g + '%' }));
  const fBranchOptions = [{ value: '', label: '' }, ...branches.map(b => extractValueLabel(b, 'branch'))];
  const fPartyOptions = fBranch
    ? [{ value: '', label: '' }, ...fParties.map(p => extractValueLabel(p, 'party'))]
    : [{ value: '', label: '' }, ...allParties.map(p => extractValueLabel(p, 'party'))];

  async function handleFBranchChange(v) {
    setFBranch(v);
    setFParty('');
    setFParties([]);
    if (!v) return;
    try {
      const res = await api.get(`/dropdown?mode=bPRT&branchId=${v}`);
      setFParties(Array.isArray(res.data) ? res.data : []);
    } catch (err) { console.error("Filter party fetch error:", err); }
  }

  const refLabel = selectedRefType?.display || 'Reference No.';
  const refPlaceholder = selectedRefType?.display ? `e.g. ${selectedRefType.display}` : 'Enter reference';

  const gstType = curParty ? (curParty.state === COMPANY.state ? 'INTRA' : 'INTER') : null;

  /* ── HANDLERS: header ── */
  async function handleBranchChange(v) {
    setBranch(v);
    setPartyCode('');
    setJobCode('');
    setParties([]);
    setJobs([]);
    if (!v) return;
    try {
      const res = await api.get(`/dropdown?mode=bPRT&branchId=${v}`);
      setParties(Array.isArray(res.data) ? res.data : []);
    } catch (err) { console.error("Party fetch error:", err); }
  }
  async function handlePartyChange(v) {
    setPartyCode(v);
    setJobCode('');
    setJobs([]);
    setPartyDetails(null);
    if (!v) return;
    try {
      const res = await api.get(`/dropdown?mode=BJOB&partyId=${v}`);
      setJobs(Array.isArray(res.data) ? res.data : []);
    } catch (err) { console.error("Job fetch error:", err); }

    try {
      const res = await api.get(`/get-BillingBranchPartysdetails/${v}`);
      setPartyDetails(res.data || null);
    } catch (err) {
      console.error("Party billing details fetch error:", err);
      setPartyDetails(null);
    }
  }
  function handleJobChange(v) {
    setJobCode(v);
  }

  /* ── HANDLERS: charge entry ── */
  function handleHeadChange(code) {
    setCHead(code);
    const h = getHeadMeta(code);
    if (h.name) {
      setCGst(String(h.gst));
      if (editIndex < 0) setCUom(h.uom);
    }
  }
  const cSac = getHeadMeta(cHead).sac;
  const lineCalc = useMemo(() => {
    const qty = parseFloat(cQty) || 0;
    const rate = parseFloat(cRate) || 0;
    const gst = parseFloat(cGst) || 0;
    const tax = qty * rate, g = tax * gst / 100;
    return { tax, g, tot: tax + g };
  }, [cQty, cRate, cGst]);

  function clearEntry() {
    setCDesc(''); setCCnr(''); setCRate('');
    setCHead('');
    setCQty('1');
    setCUom('Nos');
    setCGst('18');
    setEditIndex(-1);
  }

  function addOrUpdate() {
    if (!curParty) { toast('Select a party first', 'warn'); return; }
    if (!curJob) { toast('Select a job against the party first', 'warn'); return; }
    if (!cHead) { toast('Select a charge head', 'warn'); return; }
    const rate = parseFloat(cRate) || 0;
    if (rate <= 0) { toast('Enter a valid rate', 'warn'); return; }
    const h = getHeadMeta(cHead);
    const line = {
      head: cHead, headName: h.name, desc: cDesc.trim(), cnr: cCnr.trim().toUpperCase(),
      sac: h.sac, qty: parseInt(cQty) || 1, uom: cUom, rate, gst: parseFloat(cGst) || 0,
    };
    if (editIndex >= 0) {
      setLines(ls => ls.map((l, i) => (i === editIndex ? line : l)));
      toast('Charge updated', 'ok');
    } else {
      setLines(ls => [...ls, line]);
      toast('Charge added', 'ok');
    }
    clearEntry();
  }

  function editRow(i) {
    const l = lines[i];
    setEditIndex(i);
    setCHead(l.head);
    setCDesc(l.desc);
    setCCnr(l.cnr);
    setCQty(String(l.qty));
    setCUom(l.uom || 'Nos');
    setCRate(String(l.rate));
    setCGst(String(l.gst));
  }
  function delRow(i) {
    setLines(ls => ls.filter((_, idx) => idx !== i));
    if (editIndex === i) clearEntry();
    toast('Charge removed', 'info');
  }

  /* ── TOTALS ── */
  const totals = useMemo(() => {
    let taxable = 0, gst = 0;
    lines.forEach(l => { const t = l.qty * l.rate; taxable += t; gst += t * l.gst / 100; });
    const grand = taxable + gst, rounded = Math.round(grand), roundOff = rounded - grand;
    return { taxable, gst, grand, rounded, roundOff };
  }, [lines]);

  /* ── VIEW SWITCH ── */
  function newBill() {
    setLines([]); setEditIndex(-1);
    setCurBillNo(null);
    setBuilderTitle('Generate Additional Bill');
    setBillDate(new Date().toISOString().slice(0, 10));
    setRefType('Consignment');
    setRefNo('');
    setBranch('');
    setPartyCode('');
    setJobCode('');
    setRemark('');
    clearEntry();
    setView('builder');
  }
  function openBill(no) {
    const b = bills.find(x => x.no === no);
    if (!b) return;
    setLines(b.lines.map(l => ({ ...l })));
    setEditIndex(-1);
    setCurBillNo(b.no);
    setBuilderTitle('Edit · ' + b.no);
    setBillDate(b.date);
    setRefType(b.refType);
    setRefNo(b.refNo || '');
    const pr = allParties.find(p => extractValueLabel(p, 'party').value === b.partyCode);
    setBranch(b.branch || '');
    setPartyCode(b.partyCode || '');
    setJobCode(b.jobCode || '');
    setRemark(b.remark || '');
    clearEntry();
    setView('builder');
  }
  function showList() {
    setView('list');
    window.scrollTo(0, 0);
  }

  /* ── STATS ── */
  const stCnt = bills.length;
  const stVal = bills.reduce((a, b) => a + (b.total ?? 0), 0);
  const stTax = bills.reduce((a, b) => a + (b.gstAmount ?? 0), 0);
  const stParties = new Set(bills.map(b => b.partyId ?? b.partyCode ?? b.party)).size;

  /* ── LIST + FILTERS ──
     NOTE: mirrors RateDefinition.jsx's server-side search pattern —
     filters are only applied when "Refresh" is clicked, via a real API
     call, instead of filtering a locally-held full list on every keystroke. */
  const handleSearchBills = async () => {
    setBillsLoading(true);
    setHasSearched(true);
    try {
      const params = new URLSearchParams();
      if (fBranch) params.append('branch', fBranch);
      if (fParty) params.append('party', fParty);
      if (fFrom) params.append('fromDate', fFrom);
      if (fTo) params.append('toDate', fTo);
      const res = await api.get(`/GetAdditionalBills?${params.toString()}`);
      const rows = Array.isArray(res.data) ? res.data : [];

      // API returns one row per Additional_Bill charge line (Bill_No repeats
      // once per line) — group into one summary object per bill, matching
      // the shape the table/list view actually renders. We also keep the
      // per-line detail (sac/qty/uom/rate/gst/desc/cnr) and the raw
      // partyCode/jobCode/refType ids here — the earlier version dropped
      // these, so opening or printing a bill loaded from this register
      // came up blank (printData/openBill both need partyCode to find the
      // party's GSTIN/address, and full line fields to compute the table).
      const byBillNo = {};
      rows.forEach(r => {
        const billNo = findKeyCI(r, ['bill_No', 'billNo', 'bill_no']) ?? r.bill_No ?? r.Bill_No;
        if (!byBillNo[billNo]) {
          const branchId = findKeyCI(r, ['branch_Id', 'branchId', 'branch_id']) ?? r.branch_Id ?? r.Branch_Id;
          const partyId = findKeyCI(r, ['party_ID', 'partyId', 'party_id']) ?? r.party_ID ?? r.Party_ID;
          const jobId = findKeyCI(r, ['job_Id', 'jobId', 'job_id']);
          const refTypeId = findKeyCI(r, ['reference_Type_id', 'referenceTypeId', 'reference_type_id']);
          const branchRow = branches.find(b => extractValueLabel(b, 'branch').value === String(branchId));
          const partyRow = allParties.find(p => extractValueLabel(p, 'party').value === String(partyId));
          const taxable = r.taxable ?? r.Taxable ?? 0;
          const billTotal = r.bill_Total ?? r.Bill_Total ?? 0;
          byBillNo[billNo] = {
            no: billNo,
            date: r.bill_Date ?? r.Bill_Date,
            branch: branchId != null ? String(branchId) : '',
            branchName: branchRow ? extractValueLabel(branchRow, 'branch').label : (branchId ?? '—'),
            party: partyRow ? extractValueLabel(partyRow, 'party').label : (partyId ?? '—'),
            partyId,
            partyCode: partyId != null ? String(partyId) : '',
            jobCode: jobId != null ? String(jobId) : '',
            jobName: findKeyCI(r, ['job_Name', 'jobName']) ?? '',
            refType: refTypeId != null ? String(refTypeId) : '',
            refNo: r.against ?? r.Against ?? '',
            refTypeName: findKeyCI(r, ['reference_Name', 'referenceName']) ?? '',
            lines: [],
            taxable,
            gstAmount: billTotal - taxable,
            total: billTotal,
            status: 'generated',
            remark: findKeyCI(r, ['remark', 'narration']) ?? '',
          };
        }
        byBillNo[billNo].lines.push({
          head: findKeyCI(r, ['charge_Head_ID', 'chargeHeadId', 'charge_head_id']) ?? r.charge_Head ?? r.Charge_Head ?? '',
          headName: r.charge_Head ?? r.Charge_Head ?? '',
          desc: findKeyCI(r, ['desc', 'description']) ?? '',
          cnr: findKeyCI(r, ['against_CNR', 'againstCnr', 'against_cnr']) ?? '',
          sac: findKeyCI(r, ['sac']) ?? '',
          qty: Number(findKeyCI(r, ['qty', 'quantity']) ?? 0),
          uom: findKeyCI(r, ['uom']) ?? '',
          rate: Number(findKeyCI(r, ['rate']) ?? 0),
          gst: Number(findKeyCI(r, ['gst']) ?? 0),
        });
      });

      setBills(Object.values(byBillNo));
    } catch (err) {
      console.error('Bill search error:', err);
      setBills([]);
    } finally {
      setBillsLoading(false);
    }
  };

  const filteredBills = bills;

  const [finYearCode] = useState(1);  // FinYear_Code
  const [companyCode] = useState(1);  // Company_Code
  const [createdBy] = useState(1);    // Created_By (logged-in user id)
  const [generating, setGenerating] = useState(false);

  const statusLabels = { draft: 'Draft', generated: '✓ Generated', paid: '₹ Paid' };

  /* ── SAVE / CANCEL ── */
  function validate() {
    if (!branch) { toast('Select a branch', 'err'); window.scrollTo(0, 0); return false; }
    if (!curParty) { toast('Select a party', 'err'); window.scrollTo(0, 0); return false; }
    if (!curJob) { toast('Select a job against the party', 'err'); window.scrollTo(0, 0); return false; }
    if (!lines.length) { toast('Add at least one charge', 'warn'); return false; }
    return true;
  }
  async function saveBill(doPrint) {
    if (!validate()) return;

    const isIntra = gstType === 'INTRA';
    const totalGst = lines.reduce((a, l) => a + (l.qty * l.rate * l.gst / 100), 0);

    const payload = {
      Party_ID: parseInt(extractValueLabel(curParty, 'party').value) || 0,
      Branch_Id: parseInt(branch) || 0,
      Job_Id: parseInt(extractValueLabel(curJob, 'job').value) || null,
      Bill_Date: billDate,
      Bill_From_Date: billDate,
      Bill_to_Date: billDate,
      CGST: isIntra ? totalGst / 2 : 0,
      SGST: isIntra ? totalGst / 2 : 0,
      IGST: isIntra ? 0 : totalGst,
      Charged_Weight: 0,
      Company_Code: companyCode,
      FinYearCode: finYearCode,
      Created_By: createdBy,
      Lines: lines.map(l => ({
        Reference_Type_id: refType ? parseInt(refType) : null,
        Reference_Name: selectedRefType?.type || '',
        Reference_value: refNo.trim(),
        Charge_Head_ID: l.head ? parseInt(l.head) : null,
        Desc: l.desc,
        Against_CNR: l.cnr,
        Qty: l.qty,
        UOM: l.uom,
        GST: l.gst,
        Rate: l.rate,
      })),
    };

    setGenerating(true);
    try {
      const res = await api.post('/generate-additional-bill', payload);
      const data = res.data;

      if (data.Success || data.success) {
        const rec = {
          no: data.BillNo || data.billNo, billId: data.BillId || data.billId,
          date: billDate, branch, party: extractValueLabel(curParty, 'party').label, partyCode: extractValueLabel(curParty, 'party').value,
          jobCode: extractValueLabel(curJob, 'job').value, jobName: extractValueLabel(curJob, 'job').label,
          refType, refTypeName: selectedRefType?.type || '', refNo: refNo.trim(),
          lines: lines.map(l => ({ ...l })), status: 'generated', remark: remark.trim(),
        };

        setBills(bs => {
          const idx = bs.findIndex(b => b.no === rec.no);
          if (idx >= 0) { const copy = bs.slice(); copy[idx] = rec; return copy; }
          return [rec, ...bs];
        });

        toast((data.Message || data.message || `Bill ${rec.no} generated`) + (doPrint ? ' — printing…' : ''), 'ok');

        if (doPrint) {
          setPrintRec(rec);
          triggerRobustPrint();
        }
        setTimeout(showList, doPrint ? 700 : 500);
      } else {
        toast(data.Message || data.message || 'Failed to generate bill', 'err');
      }
    } catch (err) {
      console.error('Generate additional bill error:', err);
      toast(err.response?.data?.Message || err.response?.data?.message || 'Server error generating bill', 'err');
    } finally {
      setGenerating(false);
    }
  }
  function cancelBill() {
    if (lines.length && !window.confirm('Discard this bill?')) return;
    showList();
  }

  /* ── PRINT DATA ──
     IMPORTANT: never hard-fail to null here. The old code returned null
     (a totally blank print) the instant the party lookup failed for ANY
     reason — wrong id format, allParties still loading, a field-name
     mismatch, etc. Falling back to the data the bill row already has
     means the bill no / date / line items / totals always print, even if
     the full GSTIN/address can't be resolved for some reason. */
  const printData = useMemo(() => {
    if (!printRec) return null;

    let p;
    if (printRec.isFullAPI) {
      p = {
        name: printRec.Party_Name || printRec.party_Name || '—',
        addr: printRec.Party_Address || printRec.party_Address || printRec.Address || printRec.address || '—',
        gstin: printRec.Party_GSTIN || printRec.party_GSTIN || printRec.party_Gstin || printRec.GST_Number || printRec.gst_Number || printRec.gsT_Number || '—',
        stateName: printRec.Party_State || printRec.party_State || printRec.State_Name || printRec.state_Name || '—',
        state: (printRec.Party_State || printRec.party_State || printRec.State_Name || printRec.state_Name) ? String(printRec.Party_State || printRec.party_State || printRec.State_Name || printRec.state_Name).substring(0, 2) : '',
      };
    } else {
      const matched = allParties.find(x => extractValueLabel(x, 'party').value === printRec.partyCode);
      p = matched || {
        name: printRec.party || 'Party',
        addr: '—',
        gstin: '—',
        stateName: '—',
        state: '',
      };
    }

    const type = p.state ? (p.state === COMPANY.state ? 'INTRA' : 'INTER') : 'INTRA';
    let taxable = 0, gst = 0;

    const sourceLines = printRec.isFullAPI ? (printRec.Lines || []) : (printRec.lines || []);
    const rows = sourceLines.map((l, i) => {
      const hName = l.Charge_Head || l.charge_Head || l.headName || l.head || '—';
      const h = { name: hName, sac: l.SAC || l.sac || '—' };
      const qty = Number(l.Qty ?? l.qty) || 0;
      const rate = Number(l.Rate ?? l.rate) || 0;
      const gstPct = Number(l.GST ?? l.gst) || 0;
      const uom = l.UOM || l.uom || '';

      const t = qty * rate, g = t * gstPct / 100;
      taxable += t; gst += g;
      return { i, h, l: { ...l, qty, rate, gst: gstPct, uom }, t, g };
    });
//
    const grand = Math.round(taxable + gst);
    const roundOff = grand - (taxable + gst);
    return { p, type, rows, taxable, gst, grand, roundOff };
  }, [printRec, allParties]);

  const triggerRobustPrint = () => {
    setTimeout(() => {
      const printSection = document.querySelector('.abl-print-bill');
      if (!printSection) return;

      const iframe = document.createElement('iframe');
      iframe.style.position = 'fixed';
      iframe.style.right = '0';
      iframe.style.bottom = '0';
      iframe.style.width = '0';
      iframe.style.height = '0';
      iframe.style.border = 'none';
      document.body.appendChild(iframe);

      const doc = iframe.contentWindow.document;
      doc.open();
      doc.write('<html><head><title>Additional Bill</title>');

      // Copy all stylesheets
      document.querySelectorAll('link[rel="stylesheet"], style').forEach(el => {
        doc.write(el.outerHTML);
      });

      doc.write('</head><body class="abl-app" style="background:#fff; margin:0;">');
      // Wrap the content in abl-print-bill and force it visible
      doc.write('<div class="abl-print-bill" style="display:block!important; padding:6px; visibility:visible!important;">');
      doc.write(printSection.innerHTML);
      doc.write('</div></body></html>');
      doc.close();

      // Wait for stylesheets to load inside iframe, then print
      setTimeout(() => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => document.body.removeChild(iframe), 1000);
      }, 500);
    }, 350);
  };

  /* ── VIEW / PRINT AN EXISTING BILL FROM THE REGISTER ── */
  async function printBillRow(b, e) {
    if (e) e.stopPropagation();

    try {
      const res = await api.get(`/GetAdditionalBillForPrint?billNo=${b.no}`);
      const data = res.data;

      const fullRec = {
        no: data.Bill_No || data.bill_No || b.no,
        date: data.Bill_Date || data.bill_Date || b.date,
        partyCode: data.Party_ID || data.party_ID || data.party_Id || b.partyCode,
        party: data.Party_Name || data.party_Name || b.party,
        jobCode: data.Job_Id || data.job_Id || data.job_id || b.jobCode,
        jobName: data.Job_Name || data.job_Name || b.jobName,

        isFullAPI: true,
        Party_Name: data.Party_Name || data.party_Name,
        Party_Address: data.Party_Address || data.party_Address,
        Party_GSTIN: data.Party_GSTIN || data.party_GSTIN || data.party_Gstin,
        Party_State: data.Party_State || data.party_State,
        Lines: data.Lines || data.lines || []
      };

      const pLines = fullRec.Lines;
      fullRec.refType = pLines && pLines.length > 0 ? (pLines[0].Reference_Name || pLines[0].reference_Name) : b.refType;
      fullRec.refNo = pLines && pLines.length > 0 ? (pLines[0].Against || pLines[0].against) : b.refNo;

      setPrintRec(fullRec);
      triggerRobustPrint();
    } catch (err) {
      console.error("Failed to fetch bill details for printing", err);
      setPrintRec(b);
      triggerRobustPrint();
    }
  }

  /* ════════════════════════ RENDER ════════════════════════ */
  return (
    <div className="abl-app">
      <div className="abl-page">
        {/* ══════════ LIST VIEW ══════════ */}
        <div className={'abl-list-view' + (view !== 'list' ? ' abl-hidden' : '')}>
          <div className="abl-pg-row">
            <div className="abl-pg-title"><h1>Additional Bill Generation</h1><p>Raise supplementary bills for extra charges — detention, hamali, door delivery, storage and more</p></div>
            <div className="abl-pg-acts">
              {rights.add && (<button className="abl-btn abl-btn-primary abl-btn-lg" onClick={newBill}><IcPlus /> New Additional Bill</button>)}
            </div>
          </div>

          <div className="abl-stat-row">
            <div className="abl-stat-box abl-amber"><div className="abl-sb-val">{stCnt}</div><div className="abl-sb-lbl">Bills This Month</div></div>
            <div className="abl-stat-box abl-navy"><div className="abl-sb-val">₹{fmtK(stVal)}</div><div className="abl-sb-lbl">Total Billed</div></div>
            <div className="abl-stat-box abl-blue"><div className="abl-sb-val">₹{fmtK(stTax)}</div><div className="abl-sb-lbl">GST Collected</div></div>
            <div className="abl-stat-box abl-teal"><div className="abl-sb-val">{stParties}</div><div className="abl-sb-lbl">Parties Billed</div></div>
          </div>

          <div className="abl-card">
            <div className="abl-band abl-navy-band"><div className="abl-band-icon"><IcFilter /></div><div><div className="abl-band-title">Filters</div></div></div>
            <div className="abl-card-body">
              <div className="abl-filter-grid">
                <div className="abl-field"><label>Branch</label><AblCombo options={fBranchOptions} value={fBranch} onChange={handleFBranchChange} placeholder="All branches" /></div>
                <div className="abl-field"><label>Party</label><AblCombo options={fPartyOptions} value={fParty} onChange={setFParty} placeholder="All parties" /></div>
                <div className="abl-field"><label>From Date</label><input type="date" max={todayStr} value={fFrom} onChange={e => setFFrom(e.target.value)} /></div>
                <div className="abl-field"><label>To Date</label><input type="date" max={todayStr} min={fFrom || undefined} value={fTo} onChange={e => setFTo(e.target.value)} /></div>
                <div className="abl-field" style={{ justifyContent: 'flex-end' }}>
                  <label>&nbsp;</label>
                  <button type="button" className="abl-btn abl-btn-navy abl-btn-block" onClick={handleSearchBills} disabled={billsLoading}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ animation: billsLoading ? 'spin 1s linear infinite' : 'none' }}>
                      <path d="M2 7A5 5 0 1 0 3.5 3.5" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
                      <path d="M2 1.5v3h3" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {billsLoading ? 'Loading…' : 'Refresh'}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="abl-card">
            <div className="abl-band abl-teal-band"><div className="abl-band-icon"><IcDoc /></div><div><div className="abl-band-title">Additional Bill Register</div><div className="abl-band-sub">Click a bill to view or edit &nbsp;·&nbsp; use the print icon to reprint</div></div><div className="abl-band-r"><span className="abl-band-badge">{filteredBills.length} bills</span></div></div>
            <div className="abl-tbl-scroll">
              <table className="abl-bill-table">
                <thead><tr><th>Bill No.</th><th>Date</th><th>Branch</th><th>Party</th><th>Against</th><th className="abl-c">Charges</th><th className="abl-r">Taxable</th><th className="abl-r">GST</th><th className="abl-r">Total</th><th className="abl-c">Status</th><th className="abl-c">Print</th></tr></thead>
                <tbody>
                  {filteredBills.length === 0 ? (
                    <tr><td colSpan={11} style={{ textAlign: 'center', padding: 34, color: 'var(--abl-muted)' }}>
                      {billsLoading ? 'Loading bills…' : !hasSearched ? <>Select filters and click <strong>Refresh</strong> to view bills</> : 'No bills found'}
                    </td></tr>
                  ) : filteredBills.map(b => {
                    const t = { tax: b.taxable ?? 0, gst: b.gstAmount ?? 0, total: b.total ?? 0 };
                    return (
                      <tr key={b.no} onClick={() => openBill(b.no)}>
                        <td><span className="abl-bill-no-link">{b.no}</span></td>
                        <td style={{ color: 'var(--abl-slate)' }}>{fmtDate(b.date)}</td>
                        <td style={{ fontWeight: 600, color: 'var(--abl-teal)' }}>{b.branchName || b.branch || '—'}</td>
                        <td style={{ fontWeight: 600 }}>{b.party}{b.jobName && <div style={{ fontSize: 10.5, color: 'var(--abl-muted)', fontWeight: 600 }}>🗂 {b.jobName}</div>}</td>
                        <td style={{ fontSize: 11.5, color: 'var(--abl-muted)' }}>{b.refNo || b.refTypeName || '—'}</td>
                        <td className="abl-c"><strong style={{ color: 'var(--abl-blue)' }}>{b.lines.length}</strong></td>
                        <td className="abl-r" style={{ fontFamily: "'JetBrains Mono',monospace" }}>₹ {fmt(t.tax)}</td>
                        <td className="abl-r" style={{ fontFamily: "'JetBrains Mono',monospace", color: 'var(--abl-purple)' }}>₹ {fmt(t.gst)}</td>
                        <td className="abl-r" style={{ fontFamily: "'JetBrains Mono',monospace", fontWeight: 800, color: 'var(--abl-navy)' }}>₹ {fmt(t.total)}</td>
                        <td className="abl-c"><span className={'abl-pill abl-pill-' + b.status}>{statusLabels[b.status]}</span></td>
                        <td className="abl-c"><button type="button" className="abl-row-print-btn" title={'Print ' + b.no} onClick={e => printBillRow(b, e)}><IcPrint /></button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* ══════════ BUILDER VIEW ══════════ */}
        <div className={'abl-builder-view' + (view === 'builder' ? ' abl-active' : '')}>
          <div className="abl-pg-row">
            <div className="abl-pg-title"><h1>{builderTitle}</h1><p>Add extra/supplementary charges and generate a GST bill</p></div>
            <div className="abl-pg-acts"><button className="abl-btn abl-btn-ghost abl-btn-sm" onClick={showList}><IcBack /> Back</button></div>
          </div>

          {/* BILL HEADER */}
          <div className="abl-card">
            <div className="abl-band abl-navy-band"><div className="abl-band-icon"><IcDoc /></div><div><div className="abl-band-title">Bill Details</div><div className="abl-band-sub">Party &amp; reference</div></div></div>
            <div className="abl-card-body">
              <div className="abl-g4">
                <div className="abl-field"><label>Bill No.</label><input type="text" className="abl-ro" readOnly value={curBillNo || ''} /></div>
                <div className="abl-field"><label>Bill Date</label><input type="date" value={billDate} onChange={e => setBillDate(e.target.value)} /></div>
                <div className="abl-field"><label>Reference Type</label><AblCombo options={refTypeOptions} value={refType} onChange={setRefType} placeholder="Reference type" /></div>
                <div className="abl-field"><label>{refLabel}</label><input type="text" className="abl-mono" placeholder={refPlaceholder} style={{ textTransform: 'uppercase' }} value={refNo} onChange={e => setRefNo(e.target.value)} /></div>
              </div>
              <div className="abl-g3" style={{ marginTop: 13 }}>
                <div className="abl-field"><label>Branch <span className="abl-req">*</span></label>
                  <AblCombo options={branchOptions} value={branch} onChange={handleBranchChange} placeholder="Search branch…" />
                </div>
                <div className="abl-field"><label>Party <span className="abl-req">*</span> <span style={{ color: 'var(--abl-muted)', fontWeight: 600, textTransform: 'none' }}>{branch ? `(${partyOptions.length - 1} under ${branch})` : '(select branch first)'}</span></label>
                  <AblCombo options={partyOptions} value={partyCode} onChange={handlePartyChange} placeholder="Search party…" disabled={!branch} />
                </div>
                <div className="abl-field"><label>Job <span className="abl-req">*</span> <span style={{ color: 'var(--abl-muted)', fontWeight: 600, textTransform: 'none' }}>{partyCode ? `(${jobs.length} job${jobs.length !== 1 ? 's' : ''})` : '(select party first)'}</span></label>
                  <AblCombo options={jobOptions} value={jobCode} onChange={handleJobChange} placeholder="Search job…" disabled={!partyCode} />
                </div>
              </div>

              {/* party detail */}
              <div className={'abl-party-box' + (curParty ? ' abl-show' : '')}>
                <div className="abl-pb-grid">
                  <div><div className="abl-pb-cell-lbl">GSTIN</div><div className="abl-pb-cell-val abl-mono">{partyDetails ? (partyDetails.gsT_Number || partyDetails.gst_Number || partyDetails.GST_Number || partyDetails.Party_GSTIN || '—') : '—'}</div></div>
                  <div><div className="abl-pb-cell-lbl">State (Place of Supply)</div><div className="abl-pb-cell-val">{partyDetails ? (partyDetails.state_Name || partyDetails.State_Name || '—') : '—'}</div></div>
                  {/* <div><div className="abl-pb-cell-lbl">Billing Branch Place</div><div className="abl-pb-cell-val">{partyDetails ? (partyDetails.place_Name || partyDetails.Place_Name || '—') : '—'}</div></div> */}
                  <div><div className="abl-pb-cell-lbl">Tax Type</div><div className="abl-pb-cell-val">
                    {gstType === 'INTRA' && <span className="abl-gst-type-tag abl-gst-intra">CGST + SGST · Intra-state</span>}
                    {gstType === 'INTER' && <span className="abl-gst-type-tag abl-gst-inter">IGST · Inter-state</span>}
                    {!gstType && '—'}
                  </div></div>
                  <div style={{ gridColumn: '1/-1' }}><div className="abl-pb-cell-lbl">Billing Address</div><div className="abl-pb-cell-val" style={{ fontWeight: 600 }}>{partyDetails ? (partyDetails.place_off_address || partyDetails.Place_off_address || partyDetails.address || partyDetails.Address || '—') : '—'}</div></div>
                </div>
              </div>
            </div>
          </div>

          {/* ADD CHARGE */}
          <div className="abl-card abl-add-card">
            <div className="abl-band abl-amber-band"><div className="abl-band-icon"><IcMoney /></div><div><div className="abl-band-title">Add Charge</div><div className="abl-band-sub">Extra / supplementary charge line</div></div></div>
            <div className="abl-card-body">
              <div className="abl-add-grid">
                <div className="abl-field"><label>Charge Head <span className="abl-req">*</span></label>
                  <AblCombo options={headOptions} value={cHead} onChange={handleHeadChange} placeholder="Search charge head…" />
                </div>
                <div className="abl-field"><label>Description</label><input type="text" placeholder="Details (optional)" value={cDesc} onChange={e => setCDesc(e.target.value)} /></div>
                <div className="abl-field"><label>Against CNR</label><input type="text" className="abl-mono" placeholder="optional" style={{ textTransform: 'uppercase' }} value={cCnr} onChange={e => setCCnr(e.target.value)} /></div>
                <div className="abl-field"><label>Qty <span className="abl-req">*</span></label><input type="number" className="abl-mono" min="1" step="1" value={cQty} onChange={e => setCQty(e.target.value)} /></div>
                <div className="abl-field"><label>UOM <span className="abl-req">*</span></label><AblCombo options={uomOptions} value={cUom} onChange={setCUom} placeholder="Search UOM…" /></div>
                <div className="abl-field"><label>Rate (₹) <span className="abl-req">*</span></label><input type="number" className="abl-mono" min="0" step="0.01" placeholder="0.00" value={cRate} onChange={e => setCRate(e.target.value)} /></div>
                <div className="abl-field"><label>GST %</label><AblCombo options={gstOptions} value={cGst} onChange={setCGst} placeholder="GST %" /></div>
                <div className="abl-add-btns">
                  <button className={'abl-btn ' + (editIndex >= 0 ? 'abl-btn-teal' : 'abl-btn-amber')} onClick={addOrUpdate}><IcPlus /> <span>{editIndex >= 0 ? 'Update' : 'Add'}</span></button>
                  <button className="abl-btn abl-btn-ghost" onClick={clearEntry}>Clear</button>
                </div>
              </div>
              <div style={{ marginTop: 10, fontSize: 12, color: 'var(--abl-muted)' }}>
                SAC: <b style={{ color: 'var(--abl-slate)', fontFamily: "'JetBrains Mono',monospace" }}>{cSac}</b> · Line taxable: <b style={{ color: 'var(--abl-navy)' }}>₹{fmt(lineCalc.tax)}</b> · GST: <b style={{ color: 'var(--abl-navy)' }}>₹{fmt(lineCalc.g)}</b> · Line total: <b style={{ color: 'var(--abl-teal)' }}>₹{fmt(lineCalc.tot)}</b>
              </div>
            </div>
          </div>

          {/* CHARGES GRID */}
          <div className="abl-card">
            <div className="abl-band abl-navy-band"><div className="abl-band-icon"><IcGrid /></div><div><div className="abl-band-title">Charge Lines</div></div><div className="abl-band-r"><span className="abl-band-badge">{lines.length} line{lines.length !== 1 ? 's' : ''}</span></div></div>
            <div className="abl-tbl-scroll">
              <table className="abl-chg-grid">
                <thead><tr><th className="abl-c">#</th><th>Charge Head</th><th>Description</th><th>HSN/SAC</th><th className="abl-c">Qty</th><th className="abl-c">UOM</th><th className="abl-r">Rate</th><th className="abl-r">Taxable</th><th className="abl-c">GST%</th><th className="abl-r">GST Amt</th><th className="abl-r">Total</th><th className="abl-c">Edit</th><th className="abl-c">Del</th></tr></thead>
                <tbody>
                  {lines.length === 0 ? (
                    <tr><td colSpan={13}><div className="abl-grid-empty"><div className="abl-grid-empty-ico">🧾</div><div className="abl-grid-empty-title">No charges added</div></div></td></tr>
                  ) : lines.map((l, i) => {
                    const h = { name: l.headName || l.head };
                    const tax = l.qty * l.rate, g = tax * l.gst / 100;
                    return (
                      <tr key={i} className={i === editIndex ? 'abl-editing' : ''}>
                        <td className="abl-c"><span className="abl-cg-sn">{i + 1}</span></td>
                        <td><span className="abl-cg-head">{h.name}</span>{l.cnr && <div className="abl-cg-cnr">{l.cnr}</div>}</td>
                        <td><span className="abl-cg-desc">{l.desc || '—'}</span></td>
                        <td><span className="abl-cg-cnr">{l.sac}</span></td>
                        <td className="abl-c">{l.qty}</td>
                        <td className="abl-c"><span style={{ fontSize: 11, fontWeight: 700, color: 'var(--abl-teal)' }}>{l.uom || '—'}</span></td>
                        <td className="abl-r"><span className="abl-cg-mono">₹{fmt(l.rate)}</span></td>
                        <td className="abl-r"><span className="abl-cg-tax">₹{fmt(tax)}</span></td>
                        <td className="abl-c">{l.gst}%</td>
                        <td className="abl-r"><span className="abl-cg-mono">₹{fmt(g)}</span></td>
                        <td className="abl-r"><span className="abl-cg-tax">₹{fmt(tax + g)}</span></td>
                        <td className="abl-c"><button className="abl-ic-btn abl-ic-edit" onClick={() => editRow(i)}><IcEdit /></button></td>
                        <td className="abl-c"><button className="abl-ic-btn abl-ic-del" onClick={() => delRow(i)}><IcTrash /></button></td>
                      </tr>
                    );
                  })}
                </tbody>
                {lines.length > 0 && (
                  <tfoot>
                    <tr>
                      <td colSpan={7} className="abl-lbl">Total · {lines.length} charge{lines.length !== 1 ? 's' : ''}</td>
                      <td className="abl-r">₹ {fmt(totals.taxable)}</td>
                      <td></td>
                      <td className="abl-r">₹ {fmt(totals.gst)}</td>
                      <td className="abl-r">₹ {fmt(totals.taxable + totals.gst)}</td>
                      <td colSpan={2}></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>

          {/* SUMMARY */}
          <div className="abl-summary-wrap">
            <div className="abl-card" style={{ margin: 0 }}>
              <div className="abl-band abl-teal-band"><div className="abl-band-icon"><IcNote /></div><div><div className="abl-band-title">Notes</div></div></div>
              <div className="abl-card-body"><div className="abl-field"><label>Remark / Narration <span style={{ color: 'var(--abl-muted)', fontWeight: 600, textTransform: 'none' }}>(prints on bill)</span></label><textarea rows={3} placeholder="e.g. Detention for 2 days at Latur godown against CNR STL-2604-00847" value={remark} onChange={e => setRemark(e.target.value)} /></div></div>
            </div>
            <div className="abl-tax-card">
              <div className="abl-band abl-navy-band"><div className="abl-band-icon"><IcTax /></div><div><div className="abl-band-title">Tax Summary</div></div></div>
              <div className="abl-tax-rows">
                <div className="abl-tax-row"><span className="abl-tk">Taxable Value</span><span className="abl-tv">₹ {fmt(totals.taxable)}</span></div>
                {gstType === 'INTRA' && (<>
                  <div className="abl-tax-row"><span className="abl-tk">CGST</span><span className="abl-tv">₹ {fmt(totals.gst / 2)}</span></div>
                  <div className="abl-tax-row"><span className="abl-tk">SGST</span><span className="abl-tv">₹ {fmt(totals.gst / 2)}</span></div>
                </>)}
                {gstType === 'INTER' && (
                  <div className="abl-tax-row"><span className="abl-tk">IGST</span><span className="abl-tv">₹ {fmt(totals.gst)}</span></div>
                )}
                {!gstType && (
                  <div className="abl-tax-row"><span className="abl-tk">GST</span><span className="abl-tv">₹ {fmt(totals.gst)}</span></div>
                )}
                <div className="abl-tax-row abl-sub"><span className="abl-tk">Round Off</span><span className="abl-tv">{totals.roundOff >= 0 ? '+' : ''}₹ {fmt(totals.roundOff)}</span></div>
              </div>
              <div className="abl-tax-grand"><span className="abl-tax-grand-lbl">Grand Total</span><span className="abl-tax-grand-val">₹ {fmt(totals.rounded)}</span></div>
              <div style={{ padding: '14px 16px 16px' }}><div className="abl-words-card"><div className="abl-words-lbl">Amount in Words</div><div className="abl-words-val">{totals.rounded > 0 ? numWords(totals.rounded) : '—'}</div></div></div>
            </div>
          </div>

          {/* ACTION BAR */}
          <div className="abl-action-bar">
            <div className="abl-action-bar-inner">
              <div className="abl-ab-summary">
                <div><div className="abl-ab-sum-val">{lines.length}</div><div className="abl-ab-sum-lbl">Charges</div></div>
                <div><div className="abl-ab-sum-val">₹{fmtK(totals.rounded)}</div><div className="abl-ab-sum-lbl">Bill Total</div></div>
              </div>
              <div className="abl-ab-actions">
                <button className="abl-btn abl-btn-ghost" onClick={cancelBill}>Cancel</button>
                {rights.add && (<button className="abl-btn abl-btn-navy" onClick={() => saveBill(false)} disabled={generating}>{generating ? 'Saving…' : <><IcSave /> Save</>}</button>)}
                {rights.export && (<button className="abl-btn abl-btn-green" onClick={() => saveBill(true)} disabled={generating}>{generating ? 'Generating…' : <><IcPrint /> Generate &amp; Print</>}</button>)}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PRINT AREA */}
      <div className="abl-print-bill">
        {!printData && (
          <div style={{ padding: 30, textAlign: 'center', color: '#64748b', fontSize: 13 }}>
            {printRec ? 'Could not build this bill for printing — the data came back incomplete.' : 'No bill selected to print. Go back and click the print icon on a bill row, or Generate & Print from the form.'}
          </div>
        )}
        {printData && (
          <>
            <div className="abl-pi-hdr">
              <div><div className="abl-pi-co">{COMPANY.name}</div><div className="abl-pi-co-sub">{COMPANY.addr}<br />GSTIN: {COMPANY.gstin} · State: {COMPANY.stateName} ({COMPANY.state})</div></div>
              <div><div className="abl-pi-title">ADDITIONAL BILL</div><div className="abl-pi-tag">Supplementary Tax Invoice</div></div>
            </div>
            <div className="abl-pi-meta">
              <div><span style={{ color: '#64748b' }}>Bill No:</span> <b>{printRec.no}</b></div>
              <div><span style={{ color: '#64748b' }}>Date:</span> <b>{fmtDate(printRec.date)}</b></div>
              <div><span style={{ color: '#64748b' }}>Job:</span> <b>{printRec.jobCode ? (printRec.jobCode + (printRec.jobName ? ' · ' + printRec.jobName : '')) : (printRec.jobName || '—')}</b></div>
              <div><span style={{ color: '#64748b' }}>{printRec.refTypeName || 'Reference'}:</span> <b>{printRec.refNo || '—'}</b></div>
            </div>
            <div className="abl-pi-parties">
              <div className="abl-pi-pcard"><div className="abl-pi-pk">Bill To</div><div className="abl-pi-pv"><b>{printData.p.name}</b><br />{printData.p.addr}<br />GSTIN: {printData.p.gstin}<br />State: {printData.p.stateName} ({printData.p.state})</div></div>
              <div className="abl-pi-pcard"><div className="abl-pi-pk">Place of Supply</div><div className="abl-pi-pv"><b>{printData.p.stateName} ({printData.p.state})</b><br />Tax: {printData.type === 'INTRA' ? 'CGST + SGST (Intra-state)' : 'IGST (Inter-state)'}</div></div>
            </div>
            <table className="abl-print-tbl">
              <thead><tr><th>#</th><th>Particulars</th><th>SAC</th><th>Qty</th><th>UOM</th><th className="abl-r">Rate</th><th className="abl-r">Taxable</th><th>GST%</th><th className="abl-r">GST</th><th className="abl-r">Amount</th></tr></thead>
              <tbody>
                {printData.rows.map(({ i, h, l, t, g }) => (
                  <tr key={i}>
                    <td>{i + 1}</td>
                    <td>{h.name}{l.cnr ? ' · ' + l.cnr : ''}{l.desc && <><br /><span style={{ color: '#64748b', fontSize: 10 }}>{l.desc}</span></>}</td>
                    <td>{l.sac}</td>
                    <td style={{ textAlign: 'center' }}>{l.qty}</td>
                    <td style={{ textAlign: 'center' }}>{l.uom || '—'}</td>
                    <td className="abl-r">{fmt(l.rate)}</td>
                    <td className="abl-r">{fmt(t)}</td>
                    <td style={{ textAlign: 'center' }}>{l.gst}%</td>
                    <td className="abl-r">{fmt(g)}</td>
                    <td className="abl-r">{fmt(t + g)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr><td colSpan={8} style={{ textAlign: 'right', fontWeight: 700 }}>Taxable Value</td><td className="abl-r" colSpan={2} style={{ fontWeight: 700 }}>₹ {fmt(printData.taxable)}</td></tr>
                {printData.type === 'INTRA' ? (
                  <>
                    <tr><td colSpan={8} style={{ textAlign: 'right' }}>CGST</td><td className="abl-r" colSpan={2}>₹ {fmt(printData.gst / 2)}</td></tr>
                    <tr><td colSpan={8} style={{ textAlign: 'right' }}>SGST</td><td className="abl-r" colSpan={2}>₹ {fmt(printData.gst / 2)}</td></tr>
                  </>
                ) : (
                  <tr><td colSpan={8} style={{ textAlign: 'right' }}>IGST</td><td className="abl-r" colSpan={2}>₹ {fmt(printData.gst)}</td></tr>
                )}
                <tr><td colSpan={8} style={{ textAlign: 'right' }}>Round Off</td><td className="abl-r" colSpan={2}>{printData.roundOff >= 0 ? '+' : ''}₹ {fmt(printData.roundOff)}</td></tr>
                <tr style={{ background: '#eef2ff' }}><td colSpan={8} style={{ textAlign: 'right', fontWeight: 800 }}>Grand Total</td><td className="abl-r" colSpan={2} style={{ fontWeight: 800 }}>₹ {fmt(printData.grand)}</td></tr>
              </tfoot>
            </table>
            <div style={{ marginTop: 8, fontSize: 11 }}><b>Amount in words:</b> {numWords(printData.grand)}</div>
            {printRec.remark && <div style={{ marginTop: 6, fontSize: 11, color: '#475569' }}><b>Remark:</b> {printRec.remark}</div>}
            <div style={{ marginTop: 30, display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#475569' }}>
              <div>Received the above services / charges</div>
              <div style={{ textAlign: 'right' }}>For {COMPANY.name}<br /><br />Authorised Signatory</div>
            </div>
          </>
        )}
      </div>

      <div className="abl-toast-wrap">
        {toasts.map(t => (
          <div key={t.id} className={'abl-toast abl-' + t.type}>
            <span style={{ fontSize: 15 }}>{{ ok: '✓', err: '✕', warn: '⚠', info: 'ℹ' }[t.type] || 'ℹ'}</span>{t.msg}
          </div>
        ))}
      </div>
    </div>
  );
}
